import React from 'react';
import { EstimationResponse } from 'src/services/interfaces/ai';
import { useOnboardingStore } from '@features/onboarding/store/onboarding';
import { useFinalSubmissionStore } from 'src/store/final-submission';
import { HereYourPlans } from './HereYourPlans';

interface UnderwritingResultProps {
  onContinue: () => void;
  onViewOptions: () => void;
}

export const UnderwritingResult: React.FC<UnderwritingResultProps> = ({
  onContinue,
  onViewOptions,
}) => {
  const { data } = useOnboardingStore();
  const { underwritingResult } = useFinalSubmissionStore();
  const isAccepted = underwritingResult?.status === 'accepted';
  const isRejected = underwritingResult?.status === 'rejected';

  const primaryApplicant = data.applicants?.[0];
  const primaryApplicantName = primaryApplicant
    ? primaryApplicant.firstName
    : '';

  return <HereYourPlans isUnderwritingResult={true}>
    {/* <section className="mt-8 lg:mt-16 pb-6">
      <h2 className="text-[18px] font-extrabold mb-2">
        Health Insurance options
      </h2>
      <p className="text-[15px] mb-2 leading-5 max-w-186 !font-secondary tracking-tight">
        {primaryApplicantName}, you may be eligible for coverage through the
        Affordable Care Act (ACA), which offers comprehensive plans regardless
        of pre-existing conditions.
        <br />
        If you’d like help reviewing your options, just reach out—we’re happy
        to guide you through it.
      </p>
      <a
        href="#"
        className="text-xl text-primary font-extrabold !font-secondary"
      >
        Click here to explore Affordable Care Act Plans
      </a>
    </section> */}
  </HereYourPlans>;
};
